import React, { Component } from 'react';
import { ReactComponent as AzureLogoSvg } from 'app/assets/logos/azure-logo.svg';

export default class AzureLogo extends Component {
  render() {
    const { iconSize, color, ...props } = this.props;
    return <AzureLogoSvg {...props} />;
  }
}
